"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var HealthHistory_1 = require("./HealthHistory");
exports.HealthHistory = HealthHistory_1.HealthHistory;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy90ZXN0L1NhbXBsZS9wYXJ0cy9IZWFsdGhIaXN0b3J5L2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsaURBQTZDO0FBQXJDLHdDQUFBLGFBQWEsQ0FBQSJ9